module.exports = __webpack_public_path__ + "img/theatre_5.573e3e90.jpg";